import React from 'react';
import './NoticeDetail.css';

const NoticeDetail = ({ notice, onBack, onSign }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('zh-HK');
  };

  const getStatusText = (notice) => {
    const hasUnsigned = notice.studentResponses.some(response => !response.signed);
    if (hasUnsigned) {
      return '未簽';
    }
    return '已簽';
  };

  const getStatusClass = (notice) => {
    const hasUnsigned = notice.studentResponses.some(response => !response.signed);
    if (hasUnsigned) {
      return 'status-unsigned';
    }
    return 'status-signed';
  };

  const getStudentInfo = () => {
    // In a real app, this would get the current user's child info
    const student = notice.studentResponses[0];
    return student;
  };

  const student = getStudentInfo();

  return (
    <div className="notice-detail-container">
      <div className="notice-detail-header">
        <button className="back-button" onClick={onBack}>
          ← 通告
        </button>
        <h2>通告詳情</h2>
      </div>

      <div className="notice-detail-content">
        {/* Notice Header */}
        <div className="notice-detail-title">
          <h1>{notice.title}</h1>
          <div className="notice-detail-meta">
            <span className="notice-id">{notice.id}</span>
            <span className="notice-dates">
              {formatDate(notice.publishDate)} - {formatDate(notice.responseDeadline)}
            </span>
          </div>
        </div>

        {/* Notice Content */}
        <div className="notice-detail-body">
          <p>{notice.content}</p>
        </div>

        {/* Student Information */}
        <div className="student-info-section">
          <h3>學生資料</h3>
          <div className="student-details">
            <div className="student-name">
              <strong>學生姓名:</strong> {student.studentName} ({student.studentId})
            </div>
            <div className="student-class">
              <strong>班別:</strong> {student.studentId.split('-')[0]}
            </div>
          </div>
        </div>

        {/* Signing Status */}
        <div className="signing-status-section">
          <h3>簽署狀況</h3>
          <div className={`signing-status ${getStatusClass(notice)}`}>
            {getStatusText(notice)}
          </div>
          {student.signed && (
            <div className="signing-details">
              <p><strong>簽署人:</strong> {student.signedBy}</p>
              <p><strong>簽署時間:</strong> {student.signedAt}</p>
            </div>
          )}
        </div>

        {/* Target Audience */}
        <div className="target-audience-section">
          <h3>適用對象</h3>
          <p>
            {notice.targetAudience.includes('all') 
              ? '全校學生' 
              : notice.targetAudience.join(', ')
            }
          </p>
        </div>

        {/* Actions Required */}
        {notice.actions && notice.actions.length > 0 && (
          <div className="actions-section">
            <h3>需要回覆</h3>
            <div className="actions-list">
              {notice.actions.map((action) => (
                <div key={action.id} className="action-item">
                  <div className="action-header">
                    <span className="action-title">{action.title}</span>
                    {action.required && <span className="required-badge">必填</span>}
                  </div>
                  {action.options && (
                    <div className="action-options">
                      {action.options.map((option, index) => (
                        <span key={index} className="action-option">
                          {option}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Sign Button */}
        {!student.signed && (
          <div className="sign-action-section">
            <button 
              className="sign-notice-button"
              onClick={() => onSign(notice)}
            >
              簽署通告
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NoticeDetail;
